// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#bfcbd9","menuActiveText":"#409EFF","subMenuActiveText":"#f4f4f5","menuBg":"#001524","menuHover":"#263445","subMenuBg":"#00294d","subMenuHover":"#0087fa","sideBarWidth":"210px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/variables.scss
// module id = syC2
// module chunks = 120